import React, { Component } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import { CHECKOUT, PRODUCT_DETAIL } from 'constants/page-names';
import LiveChatMock from 'components/livechat/livechat-mock';

class LiveChat extends Component {
    static propTypes = {
        pageName: PropTypes.string.isRequired,
        isMobile: PropTypes.bool.isRequired,
        panelFacet: PropTypes.string,
        isPanelOpen: PropTypes.bool.isRequired,
        isScrollLocked: PropTypes.bool.isRequired,
    };
    static defaultProps = {};

    static shouldHide = ({ isMobile, pageName, isPanelOpen, isScrollLocked, panelFacet }) => {
        // we have different rules for this component depending on the viewport size see https://jira.migros.net/browse/MCART-2086
        return isMobile && (isPanelOpen || isScrollLocked || [PRODUCT_DETAIL, CHECKOUT].includes(pageName)) ||
            isPanelOpen && panelFacet === 'cart';
    };

    state = {
        isReady: false,
        hideMock: false,
    };

    constructor(props) {
        super(props);
        // this.onActivateWidget();
    }

    componentWillUpdate(nextProps) {
        if (!this.state.isReady) {
            return;
        }

        if (LiveChat.shouldHide(nextProps)) {
            this.hide();
        } else {
            this.show();
        }
    }

    onActivateWidget = () => {
        return new Promise((resolve) => {
            // Code provided by the 3rd party service
            /* eslint-disable */
            window.$zopim || ((d, s) => {
                var z = window.$zopim = function(c) {
                    z._.push(c);
                }, $ = z.s =
                    d.createElement(s), e = d.getElementsByTagName(s)[0];
                z.set = function(o) {
                    z.set._.push(o);
                };
                z._ = [];
                z.set._ = [];
                $.async = !0;
                $.setAttribute('charset', 'utf-8');
                $.src = '//v2.zopim.com/?5g4as0sXLH3blBL5Cw53HSjbZwiSZvI2';
                z.s.onload = () => {
                    this.setState({
                        hideMock: true,
                        isReady: true,
                    });
                    resolve();
                };
                z.t = +new Date;
                $.type = 'text/javascript';
                e.parentNode.insertBefore($, e);
            })(document, 'script');
            /* eslint-enable */
        });
    };

    onWidgetClicked = () => {
        this.onActivateWidget()
            .then(() => {
                window.$zopim.livechat.window.toggle();
            });
    };

    hide() {
        window.$zopim.livechat.hideAll();
    }

    show() {
        window.$zopim.livechat.window.hide();
    }

    render() {
        if (LiveChat.shouldHide(this.props) || this.state.hideMock) {
            return null;
        }

        return <LiveChatMock activate={ this.onWidgetClicked }/>;
    };
}

export default connect(
    reduxUtils.mapStateToProps({
        isMobile: 'viewport.isMobile',
        isScrollLocked: 'scroll.isLocked',
        isPanelOpen: 'panel.isOpen',
        panelFacet: 'panel.facet',
        pageName: 'router.name',
    }),
)(LiveChat);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/livechat/index.js